import { Component } from 'react';
import Banner from '../components/common/Banner';

export default class About extends Component {
  render() {
    return (
      <div>
        {/* Page Title */}
        <Banner title={"About Us"} desc={"About Us"} img={"images/bg/bg_1.jpg"} />

        {/* About Section */}
        <section className="section about-page">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <h2 className="title-color">Building Lifelong Bonds</h2>
              </div>
              <div className="col-lg-8">
                <p>
                  Varenya Matrimonial is committed to helping you find your ideal life partner. Through personalized matchmaking and a trusted platform, we bring together compatible individuals for meaningful, lasting relationships rooted in shared values and aspirations.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="fetaure-page">
          <div className="container">
            <div className="row">
              {[1, 2, 3, 4].map((item, index) => (
                <div key={index} className="col-lg-3 col-md-6">
                  <div className="about-block-item mb-5 mb-lg-0 text-center">
                    <img
                      src={`images/about/about-${item}.jpg`}
                      alt=""
                      className="img-fluid w-100"
                    />
                    <h4 className="mt-3">
                      {[
                        "Tailored Matchmaking",
                        "Trusted Profiles",
                        "Exclusively For Brahmins",
                        "Personalized Search"
                      ][index]}
                    </h4>
                    <p>
                      {[
                        "Where Traditions Meet Compatibility.",
                        "Verified identities for meaningful connections.",
                        "A dedicated space honoring Brahmin traditions and values.",
                        "Find matches that truly reflect your expectations."
                      ][index]}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Success Stories 
        <section className="section team">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="section-title text-center">
                  <h2 className="mb-4">Our Success Stories</h2>
                  <div className="divider mx-auto my-4"></div>
                  <p>Discover the joy of love through our heartwarming success stories. Find your perfect match with Varenya Matrimonial today!</p>
                </div>
              </div>
            </div>

            <div className="row">
              {[
                { name: "Unlocking Soon", desc: "Wait for Updated", img: 1 },
                { name: "Unlocking Soon", desc: "Wait for Updated", img: 1 },
                { name: "Unlocking Soon", desc: "Wait for Updated", img: 1 },
                { name: "Unlocking Soon", desc: "Wait for Updated", img: 1 }
              ].map((member, index) => (
                <div key={index} className="col-lg-3 col-md-6 col-sm-6">
                  <div className="team-block mb-5 mb-lg-0">
                    <img src={`images/team/${member.img}.jpg`} alt="" className="img-fluid w-100" />
                    <div className="content text-center">
                      <h4 className="mt-4 mb-0"><a href="matchmaker-single.html">{member.name}</a></h4>
                      <p>{member.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>*/}
      </div>
    );
  }
}